import { type MutableRefObject } from 'react';

export const loadImages = ({
  measure,
  nodeRef,
}: {
  measure: () => void;
  nodeRef: MutableRefObject<HTMLElement | null>;
}) => {
  if (measure && nodeRef.current) {
    const nodesIMG = nodeRef.current.querySelectorAll('img');

    nodesIMG.forEach((nodeIMG) => {
      nodeIMG.onload = () => {
        try {
          measure?.();
          // eslint-disable-next-line no-empty
        } catch (_err) {}
      };
    });

    return () =>
      nodesIMG.forEach((nodeIMG) => {
        nodeIMG.onload = () => {
          try {
            measure?.();
            // eslint-disable-next-line no-empty
          } catch (_err) {}
        };
      });
  }
};
